import { useEffect, useState } from 'react';
import $ from 'jquery';
import { Link } from 'react-router-dom';

import useScreenSize from './../../hooks/useScreenSize';
import { fetchGet } from '../../hooks/fetch';

export default function Container({ className, children }) {
	const [bannerData, setBannerData] = useState([]);

	const getDefaultTop = () => {
		const mainBanner = document?.getElementsByClassName("main-visual-section")[0]?.getBoundingClientRect();
		const sideBanner = document?.getElementById("side-banner")?.getBoundingClientRect();
		const banner = document?.getElementsByClassName("page-top-banner")[0]?.getBoundingClientRect();

		const header = document?.getElementById("header")?.getBoundingClientRect();
		const footer = document?.getElementById("footer")?.getBoundingClientRect();

		var currentTop = $(window).scrollTop();
		const atHeaderBottom = currentTop + header?.height + 20;
		const atFooterTop = currentTop - header?.height;
		const beforeFooter = (footer?.top - header?.bottom) > sideBanner?.height;
		const homeDefault = 775;
		const menuDefault = 420;
		const accountDefault = 200;

		if(banner === undefined && mainBanner === undefined) {
			if(beforeFooter) { return atHeaderBottom; }
			else { return atFooterTop; }
		} else {
			if(mainBanner !== undefined) {
				if(mainBanner.bottom > header?.bottom) { return homeDefault; } 
				else { 
					if(beforeFooter) { return atHeaderBottom; }
					else { return atFooterTop; }
				}
			}
			if(banner !== undefined) {
				if(banner?.bottom > header?.bottom) { return menuDefault; } 
				else { 
					if(beforeFooter) { return atHeaderBottom; } 
					else { return atFooterTop; }
				}
			} 

			if(beforeFooter) { return atHeaderBottom; } 
			else { return accountDefault; }
		}
	}

	// scroll 인식
	$(window).scroll(function() {
		// 현재 스크롤 위치
		var bannerTop = getDefaultTop() + "px";
		//이동 애니메이션
		$(".right-banner-wrap").stop().animate({
			"top" : bannerTop
		}, 500);

	});

	const screenSize = useScreenSize();

	function goToTop() {
		document.documentElement.scrollTo({
			top: 0,
			behavior: 'smooth',
		});
	}

	function getBannerDatas() {
		fetchGet(
			`/home/sidebanners`,
			(json) => setBannerData(json.banners)
		)
	}

	useEffect(() => {
		getDefaultTop();
		getBannerDatas();
	}, []);

	return (
		<>
			<div id="container" className={className}> 
				<div className="content-wrap">
					{children}
				</div>		
			</div>
			<div id='side-banner' className="right-banner-wrap">
				{screenSize.width > 1440 ? (
					<div>
						<ul>
							{bannerData?.map((item, i) => (
								<li key={i}>
									<Link
										to={item.link}
										className="banner"
										style={{
											backgroundSize: '39px 50px',
											backgroundImage: `url(/api-tlo/file/image/${item.image})`
										}}
										target={item.linkType === 'OUT' ? '_blank' : ''}
										title={item.menuName}
									>
										<span>{item.menuName}</span>
									</Link>
								</li>
							))}
						</ul>
						<button
							type="button"
							className="scroll-top"
							onClick={goToTop}
						>
							TOP
						</button>
					</div>
				) : null}
			</div>
		</>
	);
}
